import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { UserWithCredentials, UserWithToken } from '@deckplan.io/common/users';
import { Router } from '@angular/router';
import { Mockable } from '../mocks/mockable.decorator';

export interface RegistrationData {
    success: boolean;
    userId: number;
    customerId: string;
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class AuthService {

    public currentUser: Observable<UserWithToken>;
    private readonly currentUserSubject: BehaviorSubject<UserWithToken>;

    constructor(private readonly http: HttpClient, private readonly router: Router) {
        this.currentUserSubject = new BehaviorSubject<UserWithToken>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): UserWithToken {
        return this.currentUserSubject.value;
    }

    public get currentUserId(): 'anonymous' | number {
        return this.currentUserSubject.value ? this.currentUserSubject.value.id : 'anonymous';
    }

    public login(email: string, password: string): Observable<UserWithToken> {
        return this.http.post<UserWithToken>(`${environment.apiUrl}/${environment.apiVersion}/auth/login`, {username: email, password})
            .pipe(map(user => {
                localStorage.setItem('currentUser', JSON.stringify((user)));
                this.currentUserSubject.next(user);
                return user;
            }));
    }

    public logout() {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        this.router.navigate(['/login']);
    }

    public register(user: UserWithCredentials): Observable<RegistrationData> {
        return this.http.post<RegistrationData>(`${environment.apiUrl}/${environment.apiVersion}/auth/register`, user);
    }

    public requestResetPassword(req: { email: string }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/${environment.apiVersion}/auth/request-reset`, req);
    }

    public resetPassword(tokenAndPassword: Partial<UserWithCredentials>): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/${environment.apiVersion}/auth/reset`, tokenAndPassword);
    }

    public resendVerify(email: string): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/${environment.apiVersion}/auth/resend-verify`, {email});
    }

}
